(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

// user module exposes user management functionalities for integration into a portal
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _validators = require("@mgdis/validators");
var _dateUtils = require("@mgdis/date-utils");
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
angular.module('user', ['user.services', 'user.templates', 'user.model', 'user.directives', 'user.constants', 'i18n']);
angular.module('user').config(['translateLoaderModuleProvider', function (translateLoaderModuleProvider) {
  translateLoaderModuleProvider.addModule('user');
}]);
'use strict';
angular.module('user').controller('userController', ['$scope', 'mdm', function ($scope, mdm) {
  $scope.mdm = mdm;
}]);
'use strict';
angular.module('user.constants', []).constant('USER_ROLES', {
  all: '*',
  admin: 'admin',
  user: 'user',
  guest: 'guest'
}).constant('AUTHENTICATION_EVENTS', {
  loginSuccess: 'authentication-login-success',
  loginFailed: 'authentication-login-failed',
  logoutSuccess: 'authentication-logout-success',
  sessionTimeout: 'authentication-session-timeout',
  notAuthenticated: 'authentication-not-authenticated',
  notAuthorized: 'authentication-not-authorized'
}).constant('USER_EVENTS', {
  userUpdated: 'user-updated'
});
'use strict';
angular.module('user.directives', ['mgcrea.ngStrap.popover', 'focus-if', 'configuration', 'alerts', 'form', 'pascalprecht.translate', 'user.services', 'user.templates']);
'use strict';
angular.module('user.directives').directive('accountChangePassword', ['accountManagementService', 'alertsService', 'userSessionService', 'authenticationService', 'jwtSessionService', 'AUTHENTICATION_EVENTS', '$sce', '$translate', '$rootScope', '$document', '$window', function (accountManagementService, alertsService, userSessionService, authenticationService, jwtSessionService, AUTHENTICATION_EVENTS, $sce, $translate, $rootScope, $document, $window) {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-change-password/account-change-password.html',
    scope: {
      viewConfiguration: '=',
      user: '='
    },
    link: function link(scope) {
      scope.controlInProgress = false;

      // Initialize changePassword data
      scope.changePassword = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      if (userSessionService.getUser()) {
        scope.userId = userSessionService.getUser().id;
      }
      scope.mandatoryFieldsDescription = $sce.trustAsHtml($translate.instant('user.mandatoryFieldsDescription'));

      /**
       * Listen to submit event on form
       * @returns {void}
       */
      scope.submitPasswordForm = function () {
        // display error messages when form is invalid
        if (!scope.newPasswordValidity) {
          ['old-password', 'new-password', 'confirm-password'].forEach(function (id) {
            var element = $document[0].querySelector("[identifier=\"".concat(id, "\"]"));
            // display only required error to avoid custom error disappearance on submit
            if (!(element !== null && element !== void 0 && element.value)) {
              element === null || element === void 0 || element.displayError();
            }
          });
        } else {
          scope.modifyPassword(scope.userId, scope.changePassword);
        }
      };
      /**
       * Listen to form validity event and set form validity
       * @param {object} event event
       */
      scope.setFormValidity = function (event) {
        scope.newPasswordValidity = event.detail;
      };

      /**
       * Set the "confirm-password" valitidy equal to "lastConfirmPasswordValidity"
       * Specific case for "PLAID-126601"
       * @param {object} event event
       */
      scope.onConfirmPasswordInputValid = function (event) {
        if (scope.lastConfirmPasswordValidity !== event.detail) {
          scope.checkPasswordConfirmationValidity(scope.changePassword.confirmPassword, scope.changePassword.newPassword);
        }
      };

      /**
       * Modify user password
       * @param {string} userId Id of the user whose password has to be changed
       * @param {object} changePassword - object containing old and new password
       * @returns {Promise<object>} az
       */
      scope.modifyPassword = function (userId, changePassword) {
        return accountManagementService.modifyPassword(userId, changePassword.oldPassword, changePassword.newPassword).then(function success() {
          scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-change-password.success'), 'notification-modify-password');

          // Logout when password update confirmed
          var token = jwtSessionService.jwt();
          authenticationService.logout();
          $rootScope.$broadcast(AUTHENTICATION_EVENTS.logoutSuccess, {
            token: token,
            successKey: 'password-modification'
          });
        }, function error(result) {
          if (result.status === 401) {
            scope.$broadcast('alerts', alertsService.getAlertError('user.account-change-password.error.oldPassword'), 'notification-modify-password');
          } else {
            switch (result.data && result.data.code) {
              case 'ERR_PASSWORD_UNCHANGED':
                scope.$broadcast('alerts', alertsService.getAlertError('user.account-change-password.error.passwordUnchanged'), 'notification-modify-password');
                break;
              default:
                scope.$broadcast('alerts', alertsService.getAlertError('user.account-change-password.error.default'), 'notification-modify-password');
                break;
            }
          }
        });
      };

      /**
       * Update old password value
       * @param {object} event value change event on password
       * @returns {void}
       */
      scope.oldPasswordValueChange = function (event) {
        scope.changePassword.oldPassword = event.target.value;
      };

      /**
       * Update new password value
       * @param {object} event value change event on password
       * @returns {Promise<void>}
       */
      scope.newPasswordValueChange = function (event) {
        scope.changePassword.newPassword = event.target.value;
        if (scope.changePassword.confirmPassword && scope.changePassword.newPassword) scope.checkPasswordConfirmationValidity(scope.changePassword.confirmPassword, scope.changePassword.newPassword);
        return scope.checkNewPassword(scope.changePassword.newPassword);
      };

      /**
       * Update confirm password value
       * @param {object} event value change event on password
       * @returns {void}
       */
      scope.confirmPasswordValueChange = function (event) {
        scope.changePassword.confirmPassword = event.target.value;
        scope.checkPasswordConfirmationValidity(scope.changePassword.confirmPassword, scope.changePassword.newPassword);
      };

      /**
       * Check new password value
       * @param {object} newPassword new password
       * @returns {void}
       */
      scope.checkNewPassword = _.debounce(function (newPassword) {
        if (newPassword) {
          scope.newPasswordValidation(newPassword);
        }
      }, 200);

      /**
       * validate the new password
       * @param {string} passwordToValidate password to validate
       * @returns {Promise<void>}
       */
      scope.newPasswordValidation = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(passwordToValidate) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                scope.controlInProgress = true;
                return _context.abrupt("return", accountManagementService.checkPassword(passwordToValidate).then(function (validity) {
                  scope.currentPasswordValidity = validity;
                  if (!validity.valid) {
                    scope.setPasswordInvalid(validity);
                  }
                })["finally"](function () {
                  scope.controlInProgress = false;
                }));
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();

      /**
       * Check password confirmation validity : same password as expected or required
       * @param {string} confirmationPassword confirmation password
       * @param {string} expectedPassword expected password
       * @returns {void}
       */
      scope.checkPasswordConfirmationValidity = function (confirmationPassword, expectedPassword) {
        var errorMessage = $translate.instant('user.account-user.confirmPassword.error.confirmationField');
        // case confirmation password is different from new password
        if (confirmationPassword) {
          var confirmPasswordValidity = confirmationPassword === expectedPassword;
          scope.setError('confirm-password', errorMessage, confirmPasswordValidity);
          scope.lastConfirmPasswordValidity = confirmPasswordValidity;
        }
      };

      /**
       * Show errors of the "newPassword"
       * @returns {void}
       */
      scope.onBlurNewPassword = function () {
        scope.newPasswordValidation(scope.changePassword.newPassword);
      };

      /**
       * Check errors of the "password confirmation" validity and show them
       * @returns {void}
       */
      scope.onBlurConfirmationPassword = function () {
        scope.controlInProgress = true;
        // requestAnimationFrame is necessary to react after the component render and overwrite its error
        $window.requestAnimationFrame(function () {
          if (scope.changePassword.confirmPassword && scope.changePassword.newPassword) {
            scope.checkPasswordConfirmationValidity(scope.changePassword.confirmPassword, scope.changePassword.newPassword);
          }
          scope.controlInProgress = false;
        });
      };

      /**
       * Method to set password validity on form
       * @param {string} validity validity
       * @returns {void}
       */
      scope.setPasswordInvalid = function (validity) {
        // Rules
        if (validity.brokenRules.indexOf('charsMix') >= 0) {
          var errorMessage = $translate.instant('user.account-user.newPassword.error.pattern', {
            minMatches: validity.appliedRules.charsMix.minMatches
          });
          // display charsMix error message
          scope.setError('new-password', errorMessage, false);
        }
        // Accepted chars
        if (validity.brokenRules.indexOf('acceptedChars') >= 0) {
          var _errorMessage = $translate.instant('user.account-change-password.password.error.acceptedChars');
          // display acceptedChars error message
          scope.setError('new-password', _errorMessage, false);
        }
        // MinLength
        if (validity.brokenRules.indexOf('minLength') >= 0) {
          var _errorMessage2 = $translate.instant('user.account-user.newPassword.error.minlength', {
            minLength: validity.appliedRules.minLength.value
          });
          // display minLength error message
          scope.setError('new-password', _errorMessage2, false);
        }
        scope.checkPasswordConfirmationValidity(scope.changePassword.confirmPassword, scope.changePassword.newPassword);
      };

      /**
       * Set custom error on mg-component
       * @param {string} id id
       * @param {string} errorMessage  error message
       * @param {boolean} validity field validity
       */
      scope.setError = function (id, errorMessage, validity) {
        var _$document$0$querySel;
        (_$document$0$querySel = $document[0].querySelector("[identifier=\"".concat(id, "\"]"))) === null || _$document$0$querySel === void 0 || _$document$0$querySel.setError(validity, errorMessage);
      };
    }
  };
}]);
'use strict';
angular.module('user.directives').directive('accountCreation', ['$location', 'configuration', 'accountManagementService', 'alertsService', 'validationService', 'User', function ($location, configuration, accountManagementService, alertsService, validationService, User) {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-creation/account-creation.html',
    scope: {
      viewConfiguration: '=',
      mdm: '=',
      masterdata: ''
    },
    link: function link(scope) {
      // Initialization of the user
      scope.user = new User();

      // Keep compatibility with mdm and masterdata sources, the priority is masterdata
      if (scope.masterdata && scope.masterdata.titresCivilites) {
        scope.civilitesOptions = 'civilite.title as civilite.title for civilite in civilites';
        scope.civilites = scope.masterdata.titresCivilites.items;
      } else if (scope.mdm && scope.mdm.civilites) {
        scope.civilitesOptions = 'civilite.expand.libelle.value as civilite.expand.libelle.value for civilite in civilites';
        scope.civilites = scope.mdm.civilites.array;
      } else {
        scope.civilites = [];
      }

      // Object to bind confirmation variables
      scope.confirm = {};
      scope.accountSuccessfullyCreated = false;

      /**
       * Create account for the given user
       * @param {object} user The user object, for which an account has to be created
       */
      scope.createAccount = function (user) {
        if (_.isEmpty(user.displayName)) {
          user.displayName = _.trim(_.get(user, 'name.givenName', '') + ' ' + _.get(user, 'name.familyName', ''));
        }

        // The user will be able to validate its new account thanks to this link
        var linkMail = $location.absUrl().replace($location.path(), configuration.user.accountCreationConfirmationPath);
        accountManagementService.createAccount(user, linkMail).then(function success() {
          scope.user = new User();
          scope.confirmPassword = '';
          scope.confirmEmail = '';
          scope.accountForm.$setPristine();
          // When this boolean value is set to true, all fields of the "create account" page are hidden thanks to the ng-hide
          scope.accountSuccessfullyCreated = true;
          //Get the public settings to know the
          accountManagementService.getPublicSettings().then(function (response) {
            var data = response.data;
            var delay = {};
            var defaultTokenTime = 43200; //12 hours (in seconds)

            //We parse the value into a moment() object, to easy convert
            var intervalObject = data && data.actionTokenTTL ? moment.duration(data.actionTokenTTL, 'seconds') : moment.duration(defaultTokenTime, 'seconds');

            //Create the display object
            delay.seconds = intervalObject.asSeconds();
            delay.hours = intervalObject.asHours();
            delay.days = intervalObject.asDays();
            delay.human = intervalObject.humanize();
            scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-creation.confirmation', {
              user: user,
              delay: delay
            }), 'account-creation-alerts', 'account-creation-alerts-created');
          })["catch"](function () {
            //If the query fails, 'doesnt matter', we show the standard message
            scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-creation.confirmation', {
              user: user
            }), 'account-creation-alerts', 'account-creation-alerts-created');
          });
        }, function error(result) {
          scope.accountSuccessfullyCreated = false;

          // Conflict, can be a username (code 1)  or email (code 2) conflict
          if (result.status === 409) {
            if (result.data.code === 1) {
              scope.$broadcast('alerts', alertsService.getAlertError('user.account-creation.errors.username-conflict', {
                user: user
              }), 'account-creation-alerts', 'account-creation-alerts-created');
              // Gives the focus to the field with jQuery
              $('#userId').focus();
            } else if (result.data.code === 2) {
              scope.$broadcast('alerts', alertsService.getAlertError('user.account-creation.errors.email-conflict', {
                user: user
              }), 'account-creation-alerts', 'account-creation-alerts-created');
              $('#email').focus();
            }
          } else {
            scope.$broadcast('alerts', alertsService.getAlertError('user.account-creation.errors.other-error', {
              user: user
            }), 'account-creation-alerts', 'account-creation-alerts-created');
          }
        });
      };

      /**
       * Check if email respect RFCs
       */
      scope.validationService = validationService;
    }
  };
}]);
'use strict';
angular.module('user.directives').directive('accountLoginRecover', ['accountManagementService', 'alertsService', 'validationService', function (accountManagementService, alertsService, validationService) {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-login-recover/account-login-recover.html',
    scope: {
      viewConfiguration: '='
    },
    link: function link(scope) {
      scope.validationService = validationService;
      scope.recover = {
        email: null
      };

      /**
       * Recover the email of an user
       */
      scope.recoverEmail = function () {
        accountManagementService.recoverEmail(scope.recover.email).then(function success() {
          scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-recover-informations.login-forgotten-confirmation', {
            email: scope.recover.email
          }), 'notification-recover-email');
          scope.accountLoginRecoverForm.$setPristine();
          scope.recover.email = null;
        }, function error() {
          scope.$broadcast('alerts', alertsService.getAlertError('user.account-recover-informations.login-forgotten-unknown'), 'notification-recover-email');
        });
      };
    }
  };
}]);
'use strict';
angular.module('user.directives').directive('accountPasswordRecover', ['$location', 'configuration', 'accountManagementService', 'alertsService', function ($location, configuration, accountManagementService, alertsService) {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-password-recover/account-password-recover.html',
    scope: {
      viewConfiguration: '='
    },
    link: function link(scope) {
      scope.recover = {
        userId: null
      };

      /**
       * Reset the password of a user
       * @param {string} userId The id of the user which password has to be reset
       */
      scope.resetPassword = function (userId) {
        var linkMail = $location.absUrl().replace($location.path(), configuration.user.accountResetPasswordConfirmationPath);
        accountManagementService.resetPassword(userId, linkMail).then(function success() {
          scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-recover-informations.password-forgotten-confirmation'), 'notification-reset-password');
          scope.accountPasswordRecoverForm.$setPristine();
          scope.recover.userId = null;
        }, function error() {
          scope.$broadcast('alerts', alertsService.getAlertError('user.account-recover-informations.password-forgotten-unknown'), 'notification-reset-password');
        });
      };
    }
  };
}]);
angular.module('user.directives').directive('accountPersonalInformations', ['$rootScope', '$translate', '$location', 'accountManagementService', 'alertsService', 'userSessionService', 'jwtSessionService', 'USER_EVENTS', '$sce', function ($rootScope, $translate, $location, accountManagementService, alertsService, userSessionService, jwtSessionService, USER_EVENTS, $sce) {
  /**
   * @param {object} scope scope's directive
   */
  function handleOidcAccount(scope) {
    accountManagementService.getPublicSettings().then(function (response) {
      var publicSettings = response.data;
      scope.isUnpairingAllowed = publicSettings.autoConnect === false && publicSettings.providerMandatory !== true && publicSettings.allowUnpairing === true;
      return _.find(publicSettings.oidcProviders, function (oidcProvider) {
        return oidcProvider.providerId === scope.user.providerId;
      });
    }).then(function (oidcProviderInfos) {
      scope.unpairAccountHref = accountManagementService.getUnpairingUrl(encodeURIComponent($location.absUrl()), jwtSessionService.getJwtKey());
      // Special case for an account paired with an OIDC one.
      // When these accounts are logged in from internal authentication, there is no providerId in the jwt
      var message = _.get(jwtSessionService.user(), 'providerId', false) ? 'user.user-management.providerSourceLabel' : 'user.user-management.providerPairedLabel';
      scope.providerInfos = {
        title: oidcProviderInfos.title,
        logo: oidcProviderInfos.logo,
        providerSourceLabel: $translate.instant(message, {
          providerTitle: getLinkTitle(oidcProviderInfos)
        }),
        unpairAccountBtn: $translate.instant('user.account-update-personal-settings.unpair-account-button', {
          providerTitle: oidcProviderInfos.title
        })
      };
    });
  }

  /**
   * Get OIDC title
   * @param {object} oidcProviderInfos OIDC provider informations from publicSettings
   * @returns {string} oidc title
   */
  function getLinkTitle(oidcProviderInfos) {
    if (oidcProviderInfos.homePage) {
      return '<a href="' + oidcProviderInfos.homePage + '" target="_blank">' + oidcProviderInfos.title + '</a>';
    }
    return oidcProviderInfos.title;
  }

  /**
   * True if user is from OIDC
   * @param {object} user User
   * @returns {boolean} True if the user comes from oidc
   */
  function isOidcUser(user) {
    return Boolean(user.providerId && !user.franceConnect);
  }

  /**
   * True if user is from OIDC or FranceConnect
   * @param {object} user User
   * @returns {boolean} True if the user comes from oidc or franceConnect
   */
  function isFromProvider(user) {
    return Boolean(user.providerId || user.franceConnect);
  }

  /**
   * True if user is from FranceConnect
   * @param {object} user User
   * @returns {boolean} True if the user comes from franceConnect
   */
  function isFranceConnect(user) {
    return Boolean(user.franceConnect);
  }
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-personal-informations/account-personal-informations.html',
    scope: {
      viewConfiguration: '=',
      mdm: '=',
      masterdata: '=',
      user: '=?'
    },
    link: function link(scope) {
      // Init kendo config for birthdate property
      scope.birthdatePickerConfig = {
        min: '01/01/1900',
        max: new Date(),
        culture: 'fr-FR'
      };
      scope.mandatoryFieldsDescription = $sce.trustAsHtml($translate.instant('user.mandatoryFieldsDescription'));
      var observe;
      var user = userSessionService.getUser();
      if (user) {
        scope.userPersonalInformations = angular.copy(scope.user || user).getCleanEntity();
        observe = jsonpatch.observe(scope.userPersonalInformations);
        scope.isOidcUser = isOidcUser(scope.userPersonalInformations);
        scope.isFromProvider = isFromProvider(scope.userPersonalInformations);
        scope.isFranceConnect = isFranceConnect(scope.userPersonalInformations);
        scope.familyNameMaxLenght = scope.viewConfiguration.fields.lastname.maxlength || scope.userPersonalInformations.name.familyName.length > 30 ? scope.userPersonalInformations.name.familyName.length : 30;
        scope.firstnameMaxLenght = scope.viewConfiguration.fields.firstname.maxlength || scope.userPersonalInformations.name.givenName.length > 30 ? scope.userPersonalInformations.name.givenName.length : 30;
      }

      // Keep compatibility with mdm and masterdata sources, the priority is masterdata
      if (scope.masterdata && scope.masterdata.titresCivilites) {
        scope.civilitesOptions = 'civilite.title as civilite.title for civilite in civilites';
        scope.civilites = scope.masterdata.titresCivilites.items;
      } else if (scope.mdm && scope.mdm.civilites) {
        scope.civilitesOptions = 'civilite.expand.libelle.value as civilite.expand.libelle.value for civilite in civilites';
        scope.civilites = scope.mdm.civilites.array;
      } else {
        scope.civilites = [];
      }
      if (scope.user.providerId) {
        handleOidcAccount(scope);
      } else {
        // Case when the account is OIDC but the user connected with internal authentication (ie: paired account)
        accountManagementService.getAccount(scope.user.userName, scope.mdm).then(function (user) {
          if (user.paired === true && user.meta && user.meta.providerId) {
            handleOidcAccount(scope);
          }
        });
      }

      /**
       * Save user settings
       * @param {object} user object to be saved
       */
      scope.modifyUser = function (user) {
        if (_.get(scope.userPersonalInformations, 'name.givenName') && _.get(scope.userPersonalInformations, 'name.familyName')) {
          scope.userPersonalInformations.displayName = scope.userPersonalInformations.name.givenName + ' ' + scope.userPersonalInformations.name.familyName;
        }
        var patches = jsonpatch.generate(observe);
        accountManagementService.patchAccount(user.userName, patches).then(function (result) {
          scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-update-personal-settings.success'), 'notification-change-settings');
          scope.changeUserForm.$setPristine();
          scope.updateUser(result.data.id);
        })["catch"](function () {
          scope.$broadcast('alerts', alertsService.getAlertError('user.account-update-personal-settings.error'), 'notification-change-settings');
        });
      };

      /**
       * Update user settings
       * @param {string} userId Id of the user object to be saved
       */
      scope.updateUser = function (userId) {
        accountManagementService.getAccount(userId, scope.mdm).then(function (user) {
          scope.user = user;
          $rootScope.$broadcast(USER_EVENTS.userUpdated);
        });
      };
    }
  };
}]);
'use strict';
angular.module('user.directives').directive('accountResetPassword', ['accountManagementService', 'alertsService', function (accountManagementService, alertsService) {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-reset-password/account-reset-password.html',
    scope: {
      username: '=',
      token: '=',
      viewConfiguration: '='
    },
    link: function link(scope) {
      scope.pwdManagement = {};

      /**
       * Validate the password of the user (called after a reset)
       * @param {string} newPassword The new user's password which has to be validated
       */
      scope.validatePassword = function (newPassword) {
        accountManagementService.validatePassword(scope.username, scope.token, newPassword).then(function success() {
          scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-reset-password.confirmation'), 'notification-reset-password');
          scope.resetPasswordForm.$setPristine();
          scope.pwdManagement = {};
        }, function error() {
          scope.$broadcast('alerts', alertsService.getAlertError('user.account-reset-password.error'), 'notification-reset-password');
        });
      };
    }
  };
}]);
'use strict';
angular.module('user.directives').directive('accountUpdateEmail', ['$rootScope', 'configuration', '$location', 'accountManagementService', 'alertsService', 'userSessionService', 'authenticationService', 'jwtSessionService', 'USER_EVENTS', 'AUTHENTICATION_EVENTS', '$sce', '$translate', '$document', function ($rootScope, configuration, $location, accountManagementService, alertsService, userSessionService, authenticationService, jwtSessionService, USER_EVENTS, AUTHENTICATION_EVENTS, $sce, $translate, $document) {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/account-update-email/account-update-email.html',
    scope: {
      viewConfiguration: '=',
      mdm: '=',
      user: '=?'
    },
    link: function link(scope) {
      scope.validateEmail = _validators.validateEmail;
      scope.mandatoryFieldsDescription = $sce.trustAsHtml($translate.instant('user.mandatoryFieldsDescription'));
      // Initialize the updateEmail data structure
      scope.updateEmail = {
        email: null,
        confirmEmail: null,
        oldEmail: angular.copy(scope.user.emails[0] || userSessionService.getUser().emails[0]),
        password: null
      };
      scope.isFranceConnect = scope.user.franceConnect;

      // init password validity to false only if not FranceConnect
      if (!scope.isFranceConnect) {
        scope.updateEmailForm.$setValidity('password-required', false);
        scope.updateEmailForm.$$element[0].addEventListener('submit', function () {
          // display component error when form is submit
          var element = $document[0].querySelector("[identifier=\"password\"]");
          element === null || element === void 0 || element.displayError();
        });
      }
      if (userSessionService.getUser()) {
        scope.userId = userSessionService.getUser().id;
      }

      /**
       * Modify email of a user
       * @param  {string} userId The user id
       * @param  {string} email New email address
       * @param  {string} password User's password
       * @returns {Promise} publicSettings
       */
      scope.modifyEmail = function (userId, email, password) {
        //Get the public settings to know the emailUpdate value and actionTokenTTL delay to send validation email
        return accountManagementService.getPublicSettings().then(function (response) {
          var publicSettings = response.data;
          if (publicSettings.emailUpdate === 'emailConfirm') {
            var linkMail = $location.absUrl().replace($location.path(), configuration.user.accountEmailModificationConfirmationPath);
            accountManagementService.modifyEmail(userId, email, password, linkMail).then(function success() {
              var delay = {};
              var defaultTokenTime = 43200; //12 hours (in seconds)

              //We parse the value into a moment() object, to easy convert
              var intervalObject = publicSettings && publicSettings.actionTokenTTL ? moment.duration(publicSettings.actionTokenTTL, 'seconds') : moment.duration(defaultTokenTime, 'seconds');

              //Create the display object
              delay.seconds = intervalObject.asSeconds();
              delay.hours = intervalObject.asHours();
              delay.days = intervalObject.asDays();
              delay.human = intervalObject.humanize();
              scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-update-email.success-email-confirm', {
                email: email,
                delay: delay
              }), 'notification-update-email');
            })["catch"](function (error) {
              displayError(error);
            });
          } else {
            // We assume configuration.user.emailUpdate is set to 'instant' because it's not 'emailConfirm'
            accountManagementService.modifyEmail(userId, email, password).then(function success() {
              scope.$broadcast('alerts', alertsService.getAlertSuccess('user.account-update-email.success'), 'notification-update-email');
              scope.updateUser(userId);
              scope.updateEmail = {
                oldEmail: angular.copy(email)
              };
              scope.updateEmailForm.$setPristine();

              // Logout when email update confirmed immediatly
              var token = jwtSessionService.jwt();
              authenticationService.logout();
              $rootScope.$broadcast(AUTHENTICATION_EVENTS.logoutSuccess, {
                token: token,
                successKey: 'email-confirm'
              });
            })["catch"](function (error) {
              displayError(error);
            });
          }
        })["catch"](function (error) {
          displayError(error);
        });
      };

      /**
       * Function notificating errors
       * @param {object} error Error object
       */
      function displayError(error) {
        var messageKey = 'user.account-update-email.failure';
        if (error.status === 401) {
          messageKey = 'user.account-update-email.failure-password';
          $rootScope.$broadcast(AUTHENTICATION_EVENTS.notAuthorized, true);
        }
        if (error.status === 409 && error.data && error.data.code === 3) {
          messageKey = 'user.account-update-email.failure-franceconnect';
        }
        scope.$broadcast('alerts', alertsService.getAlertError(messageKey), 'notification-update-email');
      }

      /**
       * Update a user, with the values which are in the current session
       * @param {string} userId   The user id which has to be updated
       */
      scope.updateUser = function (userId) {
        accountManagementService.getAccount(userId, scope.mdm).then(function (user) {
          scope.user = user;
          $rootScope.$broadcast(USER_EVENTS.userUpdated);
        })["catch"](function (error) {
          displayError(error);
        });
      };

      /**
       * Update password value
       * @param {object} event value change event on password
       * @returns {void}
       */
      scope.passwordValueChange = function (event) {
        scope.updateEmail.password = event.target.value;
        scope.updateEmailForm.$setValidity('password-required', !!scope.updateEmail.password);
      };
    }
  };
}]);
'use strict';
// this directive is used to integrate a small user management widget, usually in the header of a portal

angular.module('user.directives').directive('userAuthentication', ['alertsService', function (alertsService) {
  return {
    replace: true,
    transclude: false,
    templateUrl: 'user/user-directives/user-authentication/user-authentication.html',
    scope: {
      accountCreationHref: '@',
      accountRecoverHref: '@',
      alerts: '=',
      jwtSessionOnly: '=?',
      autofocus: '=?'
    },
    controller: ['$rootScope', '$scope', 'AUTHENTICATION_EVENTS', 'authenticationService', 'jwtSessionService', function ($rootScope, $scope, AUTHENTICATION_EVENTS, authenticationService, jwtSessionService) {
      $scope.loading = false;

      // We must use a new variable named 'status' for display or not errors on the fields authentication
      // because IE11 has a bug : https://github.com/angular/angular.js/issues/1206
      $scope.fields = {
        login: {
          status: null
        },
        password: {
          status: null
        }
      };
      $scope.blurFieldsAuthentication = function (fieldName) {
        if ($scope.formulaireConnexion[fieldName].$invalid) {
          $scope.fields[fieldName].status = 'error';
        } else {
          $scope.fields[fieldName].status = 'success';
        }
      };

      /**
       * Connect the user
       * @param {string} login The user's login
       * @param {string} password The user's password
       */
      $scope.connection = function (login, password) {
        $scope.loading = true;
        if ($scope.jwtSessionOnly) {
          authenticationService = jwtSessionService;
        }
        authenticationService.login(login, password).then(function () {
          $rootScope.$broadcast(AUTHENTICATION_EVENTS.loginSuccess, login);
          $scope.loading = false;
        }, function (error) {
          $rootScope.$broadcast(AUTHENTICATION_EVENTS.loginFailed, error);
          $scope.$broadcast('alerts', alertsService.getAlertError('user.authentication.error'), 'user-authentication-alerts');
          $scope.loading = false;
        });
      };
    }]
  };
}]);
'use strict';
/**
 * @module user.directives
 * @name user-management
 * @param {object} $rootScope rootScope
 * @param {object} $q q
 * @param {object} $log log
 * @param {object} $translate translate
 * @param {object} USER_EVENTS USER_EVENTS
 * @param {object} AUTHENTICATION_EVENTS AUTHENTICATION_EVENTS
 * @param {object} authenticationService authentication service
 * @param {object} userSessionService userSession service
 * @param {object} jwtSessionService jwtSession service
 * @param {object} accountManagementService accountManagement service
 * @param {object} configuration configuration
 * @description this directive is used to integrate a small user management widget, usually in the header of a portal
 * @returns {void}
 */
angular.module('user.directives').directive('userManagement', ['$rootScope', '$q', '$log', '$translate', 'USER_EVENTS', 'AUTHENTICATION_EVENTS', 'authenticationService', 'userSessionService', 'jwtSessionService', 'accountManagementService', 'configuration', function ($rootScope, $q, $log, $translate, USER_EVENTS, AUTHENTICATION_EVENTS, authenticationService, userSessionService, jwtSessionService, accountManagementService, configuration) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/user-management/user-management.html',
    scope: {
      portalId: '@',
      accountHref: '@',
      user: '=?',
      jwtSessionOnly: '=?',
      dateTimeTZ: '@'
    },
    link: function link(scope) {
      var _scope$user, _scope$dateTimeTZ;
      scope.dateTimeLastLoginLabel = $translate.instant('user.user-management.lastTimeConnected');

      // Compatibility management. userSessionService is deprecated.
      if (scope.jwtSessionOnly) {
        authenticationService = jwtSessionService;
        scope.user = scope.user || jwtSessionService.user();
      } else {
        scope.user = userSessionService.getUser();
        scope.$on(AUTHENTICATION_EVENTS.loginSuccess, function () {
          scope.user = userSessionService.getUser();
        });
        scope.$on(AUTHENTICATION_EVENTS.logoutSuccess, function () {
          scope.user = null;
        });
        scope.$on(AUTHENTICATION_EVENTS.notAuthorized, function () {
          scope.user = null;
        });
        scope.$on(USER_EVENTS.userUpdated, function () {
          scope.user = userSessionService.getUser();
        });
      }
      scope.dateTimeLastLoginFormated = (0, _dateUtils.asDatetime)((_scope$user = scope.user) === null || _scope$user === void 0 ? void 0 : _scope$user.dateTimeLastLogin, {
        timeZone: (_scope$dateTimeTZ = scope.dateTimeTZ) !== null && _scope$dateTimeTZ !== void 0 ? _scope$dateTimeTZ : configuration.timeZone,
        style: 'short'
      });

      // Do not break compatibility (earlier versions used givenName + familyName)
      // But allow to display only displayName if it is the only available information
      // this is the case when user is fetched from JWT only
      scope.$watch('user', function () {
        if (scope.user && scope.user.name && scope.user.name.givenName && scope.user.name.familyName) {
          scope.displayUser = scope.user.name.givenName + ' ' + scope.user.name.familyName;
        } else if (scope.user && scope.user.displayName) {
          scope.displayUser = scope.user.displayName;
        } else {
          scope.displayUser = '';
        }
        if (scope.user) {
          if (scope.user.franceConnect) {
            scope.providerInfos = {
              title: 'France Connect',
              logo: 'https://app.franceconnect.gouv.fr/images/fc-avatar.png',
              providerSourceLabel: $translate.instant('user.user-management.providerSourceLabel', {
                providerTitle: 'FranceConnect'
              })
            };
          } else if (jwtSessionService && _.get(jwtSessionService.user(), 'providerId', false)) {
            // We make sure the current account is NOT a paired one.
            // When these accounts are logged in from internal authentication, there is no providerId in the jwt
            scope.fetchProviderInfos().then(function (oidcProviderInfos) {
              var linkTitle;
              if (oidcProviderInfos.homePage) {
                linkTitle = '<a href="' + oidcProviderInfos.homePage + '" target="_blank">' + oidcProviderInfos.title + '</a>';
              } else {
                linkTitle = oidcProviderInfos.title;
              }
              scope.providerInfos = {
                title: oidcProviderInfos.title,
                logo: oidcProviderInfos.logoUser,
                providerSourceLabel: $translate.instant('user.user-management.providerSourceLabel', {
                  providerTitle: linkTitle
                })
              };
            })["catch"](function (error) {
              $log.error(error);
            });
          }
        }
      }, true);

      /**
       * Disconnect of the application
       */
      scope.disconnect = function () {
        var token = jwtSessionService.jwt();
        authenticationService.logout();
        $rootScope.$broadcast(AUTHENTICATION_EVENTS.logoutSuccess, {
          token: token
        });
      };
      scope.fetchProviderInfos = function () {
        return accountManagementService.getPublicSettings().then(function (response) {
          return response.data;
        }).then(function (publicSettings) {
          var userProviderId = scope.user.providerId;
          var oidcProvider = _.find(publicSettings.oidcProviders, function (oidcProvider) {
            return oidcProvider.providerId === userProviderId;
          });
          if (!oidcProvider) return $q.reject('oidc provider with id :' + userProviderId + ' not found in the public settings');
          return oidcProvider;
        });
      };
    }
  };
}]);
'use strict';
angular.module('user.directives').directive('userManagementPopover', [function () {
  return {
    replace: true,
    transclude: true,
    templateUrl: 'user/user-directives/user-management-popover/user-management-popover.html',
    scope: true
  };
}]);

},{"@mgdis/date-utils":2,"@mgdis/validators":3}],2:[function(require,module,exports){
(function(r,c){typeof exports=="object"&&typeof module<"u"?c(exports):typeof define=="function"&&define.amd?define(["exports"],c):(r=typeof globalThis<"u"?globalThis:r||self,c(r.dateUtils={}))})(this,function(r){"use strict";function c(e=new Date){const n=e.getFullYear(),t=(e.getMonth()+1).toString().padStart(2,"0"),o=e.getDate().toString().padStart(2,"0");return`${n}-${t}-${o}`}function m(){return c()}function $(){return new Date().toISOString()}class l extends Error{constructor(n){const t=`'${n}' is not a valid date`;super(t)}}class a extends Error{constructor(n){const t=`'${n}' is not a valid style`;super(t)}}function u(e,n){return Array.from({length:n-e+1},(o,i)=>String(i+e).padStart(2,"0"))}const S=u(1,12).join("|"),T=u(1,31).join("|"),v=u(0,23).join("|"),d=u(0,59).join("|"),Z=d,g=`(\\d{4})-(${S})-(${T})`,j=`(${v}):(${d}):(${Z})`,F="(\\d{3})",I=new RegExp(`^${g}$`),x=new RegExp(`^${g}T${j}.${F}Z$`);function E(e){return I.test(e)}function y(e){return x.test(e)}function D(e,{locale:n,style:t}){return Intl.DateTimeFormat(n,{dateStyle:t,timeZone:"UTC"}).format(e)}function b(e,n){if(!e)return"";if(n!=null&&n.style&&!["long","full","medium","short"].includes(n==null?void 0:n.style))throw new a(n==null?void 0:n.style);const t={locale:"default",style:"long",...n};if(e instanceof Date)return D(e,t);if(typeof e=="string"){if(!(E(e)||y(e)))throw new l(e);return D(new Date(e),t)}throw new l(e)}const s={year:"numeric",hour:"numeric",minute:"numeric"},A={long:{...s,month:"long",day:"numeric"},full:{...s,month:"long",day:"numeric",weekday:"long"},short:{...s,month:"numeric",day:"numeric"}};function M(){return Intl.DateTimeFormat().resolvedOptions().timeZone}function h(e,{timeZone:n,style:t,locale:o,showSeconds:i,forceTZ:f}){const P=M(),w=Intl.DateTimeFormat(o,{...A[t],second:i?"numeric":void 0,timeZone:n}).format(e);return P!==n||f?`${w} (${n})`:w}function L(e,n){if(!e)return"";if(n!=null&&n.style&&!["long","full","short"].includes(n==null?void 0:n.style))throw new a(n==null?void 0:n.style);const t={timeZone:"Europe/Paris",locale:"default",style:"long",forceTZ:!1,showSeconds:!1,...n};if(e instanceof Date)return h(e,t);if(typeof e=="string"){if(!y(e))throw new l(e);return h(new Date(e),t)}throw new l(e)}r.asDate=b,r.asDatetime=L,r.now=$,r.today=m,Object.defineProperty(r,Symbol.toStringTag,{value:"Module"})});


},{}],3:[function(require,module,exports){
(function(e,t){typeof exports=="object"&&typeof module<"u"?t(exports):typeof define=="function"&&define.amd?define(["exports"],t):(e=typeof globalThis<"u"?globalThis:e||self,t(e.validators={}))})(this,function(e){"use strict";const t=/^[a-zA-Z0-9!#$%&'*+\/=?^_`\{\|\}~\-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`\{\|\}~\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,n=/^[a-z0-9!#$%&'*+\/=?^_`\{\|\}~\-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`\{\|\}~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/,s=t.source,u=n.source;function o(a,{lowercased:r=!1,allowEmpty:g=!1}={}){return g&&[void 0,""].includes(a)?!0:r?n.test(a):t.test(a)}const i=/^\d{4}\-(0[1-9]|1[0-2])\-(0[1-9]|(1|2)\d{1}|3[0-1])$/,d=/^\d{4}\-(0[1-9]|1[0-2])\-(0[1-9]|(1|2)\d{1}|3[0-1])T((0|1)\d{1}|2[0-3]):(0\d{1}|[1-5][0-9]):(0?[0-9]|[1-5][0-9])(\.\d{3})?Z$/,l=i.source,f=d.source;function z(a,{type:r}){return r==="date"?i.test(a):d.test(a)}const c=/^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\s#][^\s#]*)?(?:#[^\s]*)?$/,R=c.source;function m(a){return c.test(a)}e.datePattern=l,e.dateRegex=i,e.dateTimePattern=f,e.dateTimeRegex=d,e.emailLowercasePattern=u,e.emailLowercaseRegex=n,e.emailPattern=s,e.emailRegex=t,e.uriReferencePattern=R,e.uriReferenceRegex=c,e.validateDate=z,e.validateEmail=o,e.validateURI=m,Object.defineProperty(e,Symbol.toStringTag,{value:"Module"})});


},{}]},{},[1]);
